import React from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import DataTheoremMappingForm from './DataTheoremMappingForm';
import DataTheoremCredentialForm from './DataTheoremCredentialForm';

export default function DataTheoremConfigListing(props){
    return (
        <GenericPullConfigListing 
            {...props}
            toolName={props.name}
            MappingForm={DataTheoremMappingForm}
            CredentialsForm={DataTheoremCredentialForm}
            componentName="Mobile Application"
            componentKey="mobileAppName"
        />
    )
}